const PUBLIC_URL_RE = /^https:\/\/[a-z0-9.-]+$/;

export function resolvePublicUrl(value: string | undefined): string {
  if (!value || !PUBLIC_URL_RE.test(value)) {
    throw new Error(
      `PUBLIC_URL must be set to a valid HTTPS origin (e.g. https://psihotron.ba), got: ${value}`
    );
  }
  return value;
}

let cached: string | null = null;

/** Returns the configured PUBLIC_URL. Throws on first call if env is invalid. */
export function publicOrigin(): string {
  if (cached === null) cached = resolvePublicUrl(process.env.PUBLIC_URL);
  return cached;
}

/** For tests — clear the memoized value. */
export function _resetPublicOrigin() { cached = null; }
